module.exports = __webpack_public_path__ + "static/media/weight.b25409c7.svg";